// Styles
import '../sass/main.scss';

// Javascript
import './frontend/header';
import './frontend/custom';
